import { render } from "./App.vue?vue&type=template&id=72d84cb2"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=72d84cb2&lang=css"
import "../../../../../../WebApp/Public/css/styles.css?vue&type=style&index=1&lang=css&external"
import "../../../../../../WebApp/Public/css/footer_hmenu_sns.css?vue&type=style&index=2&lang=css&external"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__